import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Spin, Button, message, Modal } from 'antd';
import TopInfo from '../../../basicElement/TopInfo';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import Cancel from './Cancel';
import UpdateView from './UpdateView';
import { getMatchOption } from '../../../shared/selectFn';
import format from '../../../shared/format';

const STATUS = {
    add: {
        add: true,
        title: '添加投诉记录',
    },
    edit: {
        edit: true,
        title: '修改投诉记录',
    },
    view: {
        view: true,
        title: '查看投诉记录',
    },
    confirm: {
        confirm: true,
        title: '确认投诉风险等级',
    }
};

export default class Update extends Component {
    static contextTypes = {
        configure: PropTypes.object
    };
    
    constructor(props) {
        super(props);
        const { type } = props;
        this.config = STATUS[type];
        this.state = {
            data: {},
            loading: false,
            editable: !(this.config.view || this.config.confirm),
        };
    }

    componentDidMount() {
        if (!this.config.add) {
            this.loadDetail();
        }
    }
    
    loadDetail = () => {
        const { record } = this.props;
        const { complaintRecordId } = record;
        this.setState({ loading: true });
        Fetch.post(API_URL.qualityManagement.getComplaintRecordDetail, {
            complaintRecordId,
        }).then(res => {
            const { data } = res;
            this.adapt(data);
            this.setState({
                data,
                loading: false,
            }, () => {
                this.queryUser();
                this.queryInvestigation();
            });
        }).catch(err => {
            this.setState({ loading: false });
        });
    }

    queryUser = () => {
        const { data } = this.state;
        const { complaintedUserName, complaintedEmployeeCode } = data;
        Fetch.post(API_URL.investigation.queryUserByKey, {
            keyword: complaintedUserName,
        }).then(res => {
            const [{ leaderName, leaderCode }] = res.datas;
            data.leaderName = leaderName;
            data.leaderCode = leaderCode;
            data.complaintedUserName = `${complaintedUserName}[${complaintedEmployeeCode}]`;
            this.setState({ data });
        }).catch(error => console.log(error));
    }

    queryInvestigation = () => {
        const { data } = this.state;
        const { investigationName } = data;
        Fetch.post(API_URL.investigation.queryInvestigationByName, {
            investigationName
        }).then(res => {
            data.investigation = res.data[0];
            this.setState({ data });
        }).catch(error => console.log(error));
    }

    adapt = (data) => {
        const { investigationSiteName, complaintPosition, comPlaintTypeList, mainResponsibleList } = data;
        const { configure } = this.context;
        const { COMPLAINT_POSITION } = configure;

        data.investigationSiteName = (investigationSiteName || '').replace(/（(\d+)）$/, '-($1)');

        data.complaintPosition = [];
        COMPLAINT_POSITION.forEach(item => {
            const { complaintConfigureId, childList } = item;
            const { complaintConfigureId: secondId } = getMatchOption(childList, 'complaintConfigureId', complaintPosition);
            if (secondId) {
                data.complaintPosition.push(complaintConfigureId);
                data.complaintPosition.push(secondId);
            }
        });

        data.complaintType = [];
        comPlaintTypeList.forEach(item => {
            const { typeId, remark } = item;
            data.complaintType.push(typeId);
            if (remark) {
                data.complaintTypeRemark = remark;
            }
        });

        data.complaintMainResponsible = [];
        mainResponsibleList.forEach(item => {
            const { mainResponsibleId, remark } = item;
            data.complaintMainResponsible.push(mainResponsibleId);
            if (remark) {
                data.complaintMainResponsibleRemark = remark;
            }
        });
    }
    
    handleChange = (data) => {
        this.setState({ data });
    }

    handleSave = () => {
        const { configure } = this.context;
        const { record } = this.props;
        const { data } = this.state;
        const { COMPLAINT_FROM, COMPLAINT_POSITION, COMPLAINT_TYPE, MAIN_RESPONSIBLE } = configure;
        const { complaintRecordId } = record;

        if (!data.complaintFrom) {
            return message.warning('请选择投诉来源！');
        } else if (getMatchOption(COMPLAINT_FROM, 'complaintConfigureId', data.complaintFrom).optionValue === '其他' && !data.complaintFromRemark) {
            return message.warning('请填写其他投诉来源备注！');
        }

        const firstComplaintPositionChildren = getMatchOption(COMPLAINT_POSITION, 'complaintConfigureId', (data.complaintPosition || [])[0]).childList || [];
        if (!data.complaintPosition || !data.complaintPosition.length) {
            return message.warning('请选择投诉人职位！');
        } else if (getMatchOption(firstComplaintPositionChildren, 'complaintConfigureId', (data.complaintPosition || [])[1]).optionValue === '其他' && !data.complaintPositionRemark) {
            return message.warning('请填写其他投诉人职位备注！');
        }
        if (!data.complaintedUserId) {
            return message.warning('请选择被投诉人！');
        }
        if (!data.happendAreaId) {
            return message.warning('请选择事件发生的区域！');
        }
        if (!data.investigationId) {
            return message.warning('请选择项目简称！');
        } else if (!data.investigationSiteId) {
            return message.warning('请选择涉及研究中心！');
        }
        if (!data.happendDate) {
            return message.warning('请选择事件发生时间！');
        }

        const complaintTypeOtherId = getMatchOption(COMPLAINT_TYPE, 'optionValue', '其他').complaintConfigureId;
        if (!data.complaintType || !data.complaintType.length) {
            return message.warning('请选择投诉内容陈述！');
        } else if ((data.complaintType || []).some(i => i == complaintTypeOtherId) && !data.complaintTypeRemark) {
            return message.warning('请填写其他投诉内容陈述备注！');
        }
        if (!data.riskLevelId) {
            return message.warning('请选择投诉风险等级！');
        }
        if (!data.possibleImpact) {
            return message.warning('请输入投诉可能造成的影响！');
        }

        const complaintMainResponsibleOtherId = getMatchOption(MAIN_RESPONSIBLE, 'optionValue', '其他').complaintConfigureId;
        if (!data.complaintMainResponsible || !data.complaintMainResponsible.length) {
            return message.warning('请选择主要责任方！');
        } else if ((data.complaintMainResponsible || []).some(i => i == complaintMainResponsibleOtherId) && !data.complaintMainResponsibleRemark) {
            return message.warning('请填写其他主要责任方备注！');
        }
        if (!data.jsEmployeeRelevanceId) {
            return message.warning('请选择与津石员工相关性！');
        }
        if (!data.complaintProcessPlanList || !data.complaintProcessPlanList.length) {
            return message.warning('请添加已采取的措施或计划！');
        } else if (data.complaintProcessPlanList.some(i => !i.planInfo || !i.planFinishDateStr || !i.responsibleUser)) {
            return message.warning('请将已采取的措施或计划填写完整！');
        }
        if (!data.processInfoId) {
            return message.warning('请选择投诉事件处理结束与否！');
        }
        if (!data.isMajorEvent && data.isMajorEvent !== 0) {
            return message.warning('请选择是否已在重大事件登记！');
        }

        const {
            investigation,
            complaintType,
            complaintTypeRemark,
            mainResponsibleList,
            complaintMainResponsible,
            complaintMainResponsibleRemark,
            complaintProcessPlanList,
            ...rest
        } = data;
        const params = { ...rest };
        params.complaintPosition = rest.complaintPosition[1];
        data.complaintType.forEach((item, index) => {
            params[`complaintTypeList[${index}].complaintRecordId`] = complaintRecordId;
            params[`complaintTypeList[${index}].typeId`] = item;
            params[`complaintTypeList[${index}].remark`] = item == complaintTypeOtherId ? complaintTypeRemark : '';
        });
        data.complaintMainResponsible.forEach((item, index) => {
            params[`complaintMainResponsibleList[${index}].complaintRecordId`] = complaintRecordId;
            params[`complaintMainResponsibleList[${index}].mainResponsibleId`] = item;
            params[`complaintMainResponsibleList[${index}].remark`] = item == complaintMainResponsibleOtherId ? complaintMainResponsibleRemark : '';
        });
        data.complaintProcessPlanList.forEach((item, index) => {
            const { planInfo, planFinishDateStr, responsibleUser, actuallyFinishDateStr } = item;
            params[`complaintProcessPlanList[${index}].complaintRecordId`] = complaintRecordId;
            params[`complaintProcessPlanList[${index}].planInfo`] = planInfo;
            params[`complaintProcessPlanList[${index}].planFinishDateStr`] = planFinishDateStr;
            params[`complaintProcessPlanList[${index}].responsibleUser`] = responsibleUser;
            params[`complaintProcessPlanList[${index}].actuallyFinishDateStr`] = actuallyFinishDateStr;
        });
        params.happendDate = format('date', data.happendDate);

        this.setState({ loading: true });
        Fetch.post(API_URL.qualityManagement.saveComplaintRecord, {
            complaintRecordId: complaintRecordId || '',
            ...params,
        }).then(res => {
            const { success } = res;
            message.success(success);
            this.setState({ loading: false }, () => {
                this.props.update();
            });
        }).catch(err => {
            this.setState({ loading: false });
        });
    }

    cancel = () => {
        const { record } = this.props;
        this.cancelRef.show(record);
    }

    confirm = () => {
        const { record } = this.props;
        const { riskLevel, complaintRecordId } = record;
        Modal.confirm({
            title: `是否确认此投诉记录的风险等级（${riskLevel}）`,
            onOk: () => {
                this.setState({ loading: true });
                Fetch.post(API_URL.qualityManagement.updateIsCompleted, {
                    complaintRecordId,
                    isCompleted: 51,
                }).then(res => {
                    const { success } = res;
                    message.success(success);
                    this.setState({ loading: false }, () => {
                        this.props.update();
                    });
                }).catch(err => {
                    this.setState({ loading: false });
                });
            }
        });
    }

    render() {
        const { update, record } = this.props;
        const { data, loading, editable } = this.state;
        const { title, add, edit, confirm } = this.config;
        const { complaintRecordNumber } = record;
        const maxHeight = (document.body || document.documentElement).clientHeight - 258 - (editable || confirm ? 28 : 0);
        return (
            <div>
                <TopInfo
                    title={add || edit ? title : `${title}-${complaintRecordNumber}`}
                    onClick={() => update()}
                />
                <Spin spinning={loading}>
                    <div style={{ marginTop: 10, maxHeight, overflowX: 'hidden', overflowY: 'auto' }}>
                        <UpdateView
                            data={data}
                            editable={editable}
                            onChange={this.handleChange}
                        />
                    </div>
                </Spin>
                {
                    editable &&
                    <div style={{ marginTop: 10, textAlign: 'center' }}>
                        <Button type="ghost" onClick={() => update()} disabled={loading}>取消</Button>
                        <Button type="primary" style={{ marginLeft: 10 }} onClick={this.handleSave} disabled={loading}>确定</Button>
                    </div>
                }
                {
                    confirm &&
                    <div style={{ marginTop: 10, textAlign: 'center' }}>
                        <Button type="ghost" onClick={this.cancel} disabled={loading}>打回</Button>
                        <Button type="primary" style={{ marginLeft: 10 }} onClick={this.confirm} disabled={loading}>确认</Button>
                    </div>
                }
                <Cancel ref={el => this.cancelRef = el} record={record} update={update} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/qualityManagement/ComplaintRegistrationForm/components/Update.js